import React from 'react'
import { Link } from 'react-router-dom';

export const Header = () => {
    return (
        <>
            <header id="header-container" className="no-shadow">
                <div id="header">
                    <div className="container">
                        <div className="left-side">
                            <div id="logo">
                                <Link to="/"><img src="images/logo.png" alt="" /></Link>
                            </div>
                            <div className="mmenu-trigger">
                                <button className="hamburger hamburger--collapse" type="button">
                                    <span className="hamburger-box">
                                        <span className="hamburger-inner"></span>
                                    </span>
                                </button>
                            </div>
                            <nav id="navigation" className="style-1">
                                <ul id="responsive">
                                    <li><Link to="/list">Inicio</Link>
                                    </li>
                                    <li><Link to="/list">Somos quero</Link>
                                    </li>
                                    <li><Link to="#">Preguntas frecuentes</Link>
                                    </li>
                                </ul>
                            </nav>
                            <div className="clearfix"></div>
                        </div>
                        {/* TODO: CAMBIAR CUANDO ESTA LOGUEADO O NO */}
                        <div className="right-side">
                            <div className="header-widget">
                                <Link to="/SignIn" className="button border with-icon"><i className="sl sl-icon-login"></i>&nbsp;Inicia Sesión</Link>&nbsp;
                                <Link to="/Register" className="button border with-icon"><i className="sl sl-icon-user-follow"></i>&nbsp;Regístrate </Link>
                            </div>
                        </div>

                        {/* <div className="right-side">
                            <div className="header-widget">
                                <div className="user-menu">
                                    <div className="user-name"><span><img src="images/dashboard-avatar.jpg" alt="" /></span>Hi, Tom!</div>
                                    <ul>
                                        <li><a href="dashboard.html"><i className="sl sl-icon-settings"></i> Dashboard</a></li>
                                        <li><a href="dashboard-messages.html"><i className="sl sl-icon-envelope-open"></i> Messages</a></li>
                                        <li><a href="dashboard-bookings.html"><i className="fa fa-calendar-check-o"></i> Bookings</a></li>
                                        <li><a href="index.html"><i className="sl sl-icon-power"></i> Logout</a></li>
                                    </ul>
                                </div>

                                <a href="dashboard-add-listing.html" className="button border with-icon">Add Listing <i className="sl sl-icon-plus"></i></a>
                            </div>
                        </div> */}
                    </div>
                </div>
            </header>
            <div className="clearfix"></div>
        </>
    )
}